import { z } from "zod";

export const CreatePlayerSessionNoScoringSchema = z.object({
	factionId: z.coerce.number().optional(),
	playerId: z.coerce.number({
		error: "player-session:new.player.required",
	}),
	won: z.boolean(),
	firstPlay: z.boolean(),
});

export const CreatePlayerSessionSchema = CreatePlayerSessionNoScoringSchema.extend({
	score: z
		.number({
			error: "player-session:score.required",
		})
		.nonnegative({
			message: "player-session:score.required",
		}),
});

export const CreateSessionSchema = z.object({
	gameId: z.coerce
		.number({ error: "player-session:new.game.required" })
		.int()
		.positive({ message: "player-session:new.game.required" }),
	locationId: z.coerce
		.number({
			error: "player-session:new.location.required",
		})
		.positive({
			message: "player-session:new.location.required",
		}),
	start: z.coerce.date({
		error: "player-session:new.start.required",
	}),
	end: z.coerce.date({
		error: "player-session:new.end.required",
	}),
	minutes: z.number().positive().optional(),
	comment: z.string().nullable(),
	playerSessions: CreatePlayerSessionSchema.or(CreatePlayerSessionNoScoringSchema).array().min(1, {
		message: "player-session:new.players.minimum",
	}),
	expansionIds: z.array(z.number()).optional(),
});

export type CreateSession = z.infer<typeof CreateSessionSchema>;
export type CreateSessionPlayer = z.infer<typeof CreatePlayerSessionSchema>;
export type CreatePlayerSessionNoScoring = z.infer<typeof CreatePlayerSessionNoScoringSchema>;
